'use strict';

var log = require('../../log/Log').channel('NavBarController');
var BatteryLevelExtension = require('./BatteryLevelExtension');
var defaults = require ('../../defaults/Defaults');
var objectToArray = require('./ObjectToArray');
var sutl = require('../../sutl/Sutl');

angular.module('inara').controller('NavBarController', NavBarController);

NavBarController.$inject = ['$scope', '$state', 'DeviceService', 
                            'KayleeService','RoomService', '$ionicPopover', 
                            '$timeout', 'gettextCatalog', '$q'];

function NavBarController($scope, $state, DeviceService,
                          KayleeService, RoomService, $ionicPopover, 
                          $timeout, gettextCatalog, $q) {
    var vm = this;
    var unwatchNetworkConnection = null;
    var lowBatteryThreshold = 45; // should match btty-lower-threshold in LTM.INI
    var previousNetworkInterfaces = null;
    var networkInterface = {};

    log.info('initializing');

    angular.extend(vm, new BatteryLevelExtension(RoomService.getController()));

    $scope.networkInfoPopover = null;
    $scope.getNetworkInterfaceInfo = getNetworkInterfaceInfo;
    $scope.onClick = hideNetworkInfoPopover;
    $scope.malName = defaults.mal.name;
    /// Network information popover - network type
    $scope.getWiredNetworkLabel = function() { return gettextCatalog.getString('Wired'); };
    /// Network information popover - network type
    $scope.getWirelessNetworkLabel = function() { return gettextCatalog.getString('Wireless'); };
    /// Network information popover - network type
    $scope.getUnknownNetworkLabel = function() { return gettextCatalog.getString('Unknown'); };
    /// Network information popover - Mira Portal connection status
    $scope.getConnectedLabel = function() { return gettextCatalog.getString('Connected'); };
    /// Network information popover - Mira Portal connection status
    $scope.getNotConnectedLabel = function() { return gettextCatalog.getString('Not connected'); };
    $scope.isMalConnected = function() { return KayleeService.isConnected(); };

    $scope.$on('$stateChangeSuccess', onStateChanged);

    $scope.$on('popover.hidden', function($event, popover) {
        if (popover === $scope.networkInfoPopover) $scope.networkInfoPopover.remove();
    });

    $scope.$on('popover.removed', function($event, popover) {
        if (popover === $scope.networkInfoPopover) $scope.networkInfoPopover = null;
    });

    $scope.$on('$destroy', function() {
        hideNetworkInfoPopover();
        if (unwatchNetworkConnection) {
            unwatchNetworkConnection();
        }
        RoomService.offStateChanged(onRoomServiceStateChanged);
    });

    RoomService.onStateChanged(onRoomServiceStateChanged);

    function onStateChanged(event, toState, toParams, fromState, fromParams) {
        hideNetworkInfoPopover();
    }

    // TODO: should we change this to use the online/offline events that the 
    // network connection plugin provides?
    unwatchNetworkConnection = $scope.$watch(
        function() { return DeviceService ? DeviceService.getNetworkConnection() : ''; }, 
        function(newValue, oldValue) {
            if (newValue === 'wifi') {
                vm.networkType = 'wireless';
                if (RoomService.isDeviceLoaded() &&
                    DeviceService) {
                    DeviceService.getCurrentWifiNetwork().then(function(ssid) {
                        vm.networkSSID = ssid;
                    });
                }
            }
            else if (newValue === 'ethernet') {
                vm.networkType = 'wired';
                vm.networkSSID = '';
            }
            else {
                vm.networkType = '';
                vm.networkSSID = '';
            }
            // invalidate cached interfaces
            previousNetworkInterfaces = '';
        }
    );

    function onRoomServiceStateChanged(state) {
        if (state === 'deviceLoaded') {
            if (vm.networkType === 'wireless' &&
                DeviceService) {
                DeviceService.getCurrentWifiNetwork().then(function(ssid) {
                    vm.networkSSID = ssid;
                });
            }
        }
        vm.batteryLevel.setController(RoomService.getController());
    }

    vm.getNetworkName = function() {
        /// Setup/startup navigation bar - network type
        if (vm.networkType === 'wired') return gettextCatalog.getString('Wired');
        return vm.networkSSID;
    };

    vm.hasNetworkButton = function() {
        return vm.networkType !== '';
    };

    vm.showNetworkInfoPopover = function($event) {
        return hideNetworkInfoPopover().then(function() {
            return $ionicPopover.fromTemplateUrl('networkInfoTooltip.html', {
                scope: $scope
            }).then(function(popover) {
                $scope.networkInfoPopover = popover;
                return $scope.networkInfoPopover.show($event);
            });
        });
    };

    function hideNetworkInfoPopover() {
        if ($scope.networkInfoPopover !== null) {
            return $scope.networkInfoPopover.hide();
        } else {
            return $q.resolve();
        }
    }

    function getNetworkInterfaceInfo() {
        var controller = RoomService.getController();

        if (angular.isDefined(controller) && 
            controller !== null &&
            controller.hasOwnProperty('networkInterfaces')) {

            if (!sutl.objEquals(controller.networkInterfaces, previousNetworkInterfaces)) {
                // cache interfaces so we don't have to regenerate network
                // interface status object every call
                previousNetworkInterfaces = angular.copy(controller.networkInterfaces);
                for (var ifName in controller.networkInterfaces) {
                    if (!controller.networkInterfaces.hasOwnProperty(ifName)) {
                        continue;
                    }
                    if (vm.networkType === 'wireless' && ifName.startsWith('wlan') ||
                        vm.networkType === 'wired' && ifName.startsWith('eth')) {
                        var iface = angular.copy(controller.networkInterfaces[ifName]);
                        networkInterface = {
                            networkType: vm.networkType, 
                            networkSSID: vm.networkSSID,
                            hardwareAddress: iface.hardwareAddress
                        };
                        networkInterface.linkAddresses = 
                            objectToArray(iface.linkAddresses).filter(function(el) {
                                // ignore link local addresses
                                return el.address && 
                                    el.family === 'ipv4' && 
                                    !el.address.startsWith('169.254');
                                    // TODO: re-enable IPv6 when we have a better way to display it
                                    //el.family === 'ipv6' && !el.address.startsWith('fe80'));
                            });
                        networkInterface.dnsServers = objectToArray(iface.dnsServers).filter(function(el) {
                            // TODO: re-enable IPv6 when we have a better way to display it
                            return el.family === 'ipv4';
                        });
                    }
                }
            }
        }
        else if (Object.keys(networkInterface).length > 0) {
            networkInterface = {};
        }

        return networkInterface;
    }

    vm.showSystemInfo = function() {
        $timeout(function() {
            $state.go('info.system');
        }, 100);
    };

    vm.showBatteryLevel = function() {
        var isStartSetupOrUpdateAndLowBattery =
            vm.batteryLevel.getLevel() < lowBatteryThreshold &&
             ($state.is('start') ||
              $state.includes('setup.**') ||
              $state.is('update'));

        // Factory install and information pages always show battery info.
        // Start, setup and update pages only show battery info if the charge
        // level is below the low battery threshold.
        return sutl.getNode(DeviceService.getCaps(), ['hasBattery'], false) &&
               vm.batteryLevel.hasLevel() && 
               ($state.is('factoryInstall') ||
               $state.includes('info.**') ||
               isStartSetupOrUpdateAndLowBattery);
    };
}

module.exports = NavBarController;
